export function formatRelative(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  const now = new Date();
  const diff = (now - d) / 1000; // positive = past, negative = future
  if (diff >= 0) {
    if (diff < 60) return 'agora mesmo';
    if (diff < 3600) return `há ${Math.floor(diff/60)}m`;
    if (diff < 86400) return `há ${Math.floor(diff/3600)}h`;
    return d.toLocaleString('pt-PT');
  }
  // future
  const f = -diff;
  if (f < 60) return 'em alguns segundos';
  if (f < 3600) return `em ${Math.ceil(f/60)}m`;
  if (f < 86400) return `em ${Math.ceil(f/3600)}h`;
  return d.toLocaleString('pt-PT');
}

export function formatAbsolute(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-PT', { hour12: false });
  } catch { return iso; }
}

export function formatClock(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit', hour12: false });
  } catch { return iso; }
}

export function shortUrl(url) {
  try {
    const u = new URL(url);
    return u.host + (u.pathname === '/' ? '' : u.pathname);
  } catch { return url; }
}
